import { gql } from "apollo-boost";

export const CREATE_SETTING = gql `
mutation CreateSetting($data: SettingInput!) {
   createSetting(data: $data) {
     id
   }
 }
  ` 

export const UPDATE_SETTINGV2 = gql`
mutation UpdateSettingV2($data: SettingInput!, $where: SettingWhereInputOne!) {
  updateSettingV2(data: $data, where: $where) {
    id
    pointRate
  }
}
`